import photos from '../data/photos.json';
import TopNav from '../components/shell/TopNav.jsx';
import PolaroidMasonry from '../components/photography/PolaroidMasonry.jsx';

export default function Photography() {
  return (
    <>
      <TopNav />
      <PolaroidMasonry photos={photos} />
    </>
  );
}
